import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {LayoutDirectivesModule} from '../directives/layoutdirectives.module';
import {HeaderComponent} from './header.component';

@NgModule({
  imports: [CommonModule, RouterModule, LayoutDirectivesModule, BsDropdownModule.forRoot()],
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
})
export class HeaderModule {}
